export default __webpack_public_path__ + "static/media/recipeAR.9cfbdda2.svg";